var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",staticStyle:{"border-top":"0"},attrs:{"id":"footer"}},[_vm._v("\n\t© 2022 Qtrust, All Rights Reserved. Version "+_vm._s(_vm.version)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }